module.exports = __webpack_public_path__ + "img/112.fc2293db.jpg";